import Section from "../../components/SubBlog/CreateAccount/Section";

const CreateAccountPage = () => {
  return (
    <>
      <Section />
    </>
  );
};

export default CreateAccountPage